import { StyledQuote } from './style';

export const Quote = ({ subject, content, type, isSavedQuote, scrollToRecord }) => (
  <StyledQuote type={type} isSavedQuote={isSavedQuote} onClick={scrollToRecord}>
    {subject}
    {content}
  </StyledQuote>
);
